import script from "./PublicInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicInvite.vue?vue&type=script&setup=true&lang=js"

import "./PublicInvite.vue?vue&type=style&index=0&id=b5f79c98&scoped=true&lang=css"

import exportComponent from "/Users/asani/Documents/NODE/Graduation/fe-gradu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5f79c98"]])

export default __exports__